const CssBaseline = (theme) => {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          width: '100%',
          minHeight: '100%',
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          width: '100%',
          minHeight: '100%',
        },
        '#root': {
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          width: '100%',
          minHeight: '100%',
          '> div': {
            display: 'flex',
            flex: '1 1 auto',
            height: '100%',
            width: '100%',
          }
        },
      },
    },
  };
};

export default CssBaseline;
